export default __webpack_public_path__ + "static/media/byc-icon.16972897.png";